<button type="button" class="btn btn-icon btn-light btn-transparent-light" *ngIf="columnName&&sortOption.sortable"
    (click)="changeSort(columnName)">
    <i class='sort-animate animate__animated bx' [ngClass]="[
    sortOption.sortColumn!=columnName ?
        'bx-sort animate__fadeIn' : '',
        sortOption.sortColumn==columnName && !sortOption.desc ?
        'bx-sort-a-z animate__fadeInDown' : '',
        sortOption.sortColumn==columnName && sortOption.desc ?
        'bx-sort-z-a animate__fadeInUp' : '',
        ]">
    </i>
</button>